import React, { createContext, useContext, useState, useEffect } from "react";

const UserRoleContext = createContext();

/**
 * Provides the user role context to its children components.
 * 
 * This provider manages the `userRole` state, initializing it from `localStorage`
 * and keeping it in sync with `localStorage` whenever it changes.
 * 
 * @component
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.children - The child components to be wrapped by the provider.
 * @returns {JSX.Element} The UserRoleContext provider with userRole state and setter.
 */
export const UserRoleProvider = ({ children }) => {
  const [userRole, setUserRole] = useState(() => {
    // Load the initial role from localStorage
    return localStorage.getItem("userRole") || null;
  });

  useEffect(() => {
    // Update localStorage whenever userRole changes
    if (userRole) {
      localStorage.setItem("userRole", userRole);
    } else {
      localStorage.removeItem("userRole");
    }
  }, [userRole]);

  return (
    <UserRoleContext.Provider value={{ userRole, setUserRole }}>
      {children}
    </UserRoleContext.Provider>
  );
};

export const useUserRole = () => useContext(UserRoleContext);
